import { useEffect, useState } from "react";
import api from "../../services/api.js";

export default function CustStickyNote({ userId, token }) {
  const [notes, setNotes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [deletingId, setDeletingId] = useState(null);

  const fetchNotes = async () => {
    try {
      setLoading(true);

      const res = await api.get(`/customer-notes/${userId}`, {
        headers: {
          Authorization: token,
        },
      });

      if (res.data?.success) {
        setNotes(res.data.data || []);
      }
    } catch (error) {
      console.error("Fetch customer notes failed:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (userId) fetchNotes();
  }, [userId]);

  const handleDelete = async (noteId) => {
    const confirmed = window.confirm("Yakin ingin menghapus catatan ini?");

    if (!confirmed) return;

    // backup state untuk rollback
    const prevNotes = [...notes];

    // optimistic UI → langsung remove dari UI
    setNotes((prev) => prev.filter((n) => n.id !== noteId));
    setDeletingId(noteId);

    try {
      const res = await api.delete(`/customer-notes/${noteId}`, {
        headers: {
          Authorization: token,
        },
      });

      if (!res.data?.success) {
        throw new Error("Delete failed");
      }
    } catch (error) {
      console.error("Delete note failed:", error);

      // rollback jika gagal
      setNotes(prevNotes);
      alert("Gagal menghapus catatan. Silakan coba lagi.");
    } finally {
      setDeletingId(null);
    }
  };

  if (loading) {
    return <div className="text-sm text-gray-500">Loading notes...</div>;
  }

  if (!notes.length) {
    return (
      <div className="text-sm text-gray-400 italic">Tidak ada sticky note</div>
    );
  }

  return (
    <div className="space-y-3">
      {notes.map((note) => (
        <div
          key={note.id}
          className="relative bg-yellow-100 border border-yellow-300 rounded-md p-3 shadow-sm m-2"
        >
          {/* Delete Button */}
          <button
            onClick={() => handleDelete(note.id)}
            disabled={deletingId === note.id}
            className="absolute top-2 right-2 text-red-500 hover:text-red-700 font-bold disabled:opacity-50"
            title="Delete note"
          >
            ×
          </button>

          {/* Note Content */}
          <div className="whitespace-pre-line text-sm text-gray-800">
            {note.notes}
          </div>

          {/* Footer */}
          <div className="mt-2 text-xs text-gray-500">
            {new Date(note.created_at).toLocaleString("id-ID")}
          </div>
        </div>
      ))}
    </div>
  );
}
